var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8312 1.16875C15.6062 0.943749 15.2416 0.943749 15.0166 1.16875L8.5 7.68536L1.98339 1.16875C1.75839 0.943749 1.39376 0.943749 1.16875 1.16875C0.943749 1.39376 0.943749 1.75839 1.16875 1.98339L7.68536 8.5L1.16875 15.0166C0.943749 15.2416 0.943749 15.6062 1.16875 15.8312C1.39376 16.0563 1.75839 16.0563 1.98339 15.8312L8.5 9.31464L15.0166 15.8312C15.2416 16.0563 15.6062 16.0563 15.8312 15.8312C16.0563 15.6062 16.0563 15.2416 15.8312 15.0166L9.31464 8.5L15.8312 1.98339C16.0563 1.75839 16.0563 1.39376 15.8312 1.16875V1.16875Z",
    stroke: "#04ADAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconGreen);
export default __webpack_public_path__ + "static/media/xIconGreen.baf13f28ad69e165241c14af15c28f58.svg";
export { ForwardRef as ReactComponent };